import { __rest } from "tslib";
import React from 'react';
import { useTheme, useMergeClasses } from '../../../../../theme';
import { Switch } from '@shared/ui/Switch';
const SearchFormSwitch = (_a) => {
    var { classes } = _a, props = __rest(_a, ["classes"]);
    const defaultClasses = useTheme('SearchForm').SearchFormSwitch;
    const css = useMergeClasses(defaultClasses, classes);
    return React.createElement(Switch, Object.assign({}, props, { classes: css }));
};
export default SearchFormSwitch;
